import theme from '@/config/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  licenseBanner: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 10,
    backgroundColor: theme.colors.newUI.therapist.orange30,
  },
  alertTriangle: {
    position: 'absolute',
    top: -8,
    left: -8,
    color: theme.colors.newUI.therapist.orange30,
  },
});
